var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "mac-version"
  }, [_c("section", {
    staticClass: "mac-version__banner-wrapper"
  }, [_c("Banner", {
    attrs: {
      title: "Mac版",
      description: "完美适配Mac原生系统，拥有快捷手势交互操作，配合自定义“独立弹窗”，大幅提高Mac端看盘效率",
      productId: _vm.productId
    }
  })], 1), _c("section", {
    staticClass: "mac-version__features-wrapper"
  }, [_c("Features", {
    attrs: {
      featuresList: _vm.featuresList
    }
  })], 1), _c("section", {
    staticClass: "mac-version__function-wrapper"
  }, [_c("Function")], 1), _c("section", {
    staticClass: "mac-version__skill-wrapper"
  }, [_c("Skill", {
    staticClass: "area",
    attrs: {
      skillList: _vm.skillList
    }
  })], 1), _c("section", {
    staticClass: "mac-version__cases-wrapper"
  }, [_c("Cases")], 1), _c("Appointment2", {
    staticClass: "appointment"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };